import './cartCostView.scss'
import { useProductOrderContext } from 'components/product-order-popup/context'

type Props = {
  accountCredit: number
}

export function CartCostView({ accountCredit }: Props) {
  const { getCartSubTotal } = useProductOrderContext()
  const subtotal = getCartSubTotal()
  const accountCreditToUse = Math.min(accountCredit, subtotal)
  const total = Math.max(0, subtotal - accountCredit)

  return (
    <div className='cart-view-items-pricing-container'>
      <div className='cart-view-title-total-container'>
        <div className='cart-view-title-text'>Description</div>
        <div className='cart-view-title-text'>Fee</div>
      </div>

      <div className='cart-view-item-container'>
        <div>Subtotal</div>
        <div>${Number(subtotal.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })}</div>
      </div>

      {accountCreditToUse > 0 ?
        <div className='cart-view-item-container'>
          <div>Account credit</div>
          <div>
            -$
            {Number(accountCreditToUse.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })}
          </div>
        </div>
      : null}
      <div className='cart-view-title-total-container total'>
        <div>Total</div>
        {`$${Number(total.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 })}`}
      </div>
    </div>
  )
}
